import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../services/api-client.js';
import VehicleCard from '../components/VehicleCard.js';

export default function InventoryPage() {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [page, setPage] = useState(1);

  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('limit', '20');
  if (search) params.set('q', search);
  if (status) params.set('status', status);

  const { data, isLoading } = useQuery({
    queryKey: ['vehicles', search, status, page],
    queryFn: () => api.get<any[]>(`/vehicles?${params.toString()}`),
  });

  const vehicles = data?.data ?? [];
  const pagination = (data as any)?.pagination;

  const STATUSES = [
    { value: '', label: 'All' },
    { value: 'intake', label: 'Intake' },
    { value: 'active', label: 'Active' },
    { value: 'pending_sale', label: 'Pending' },
    { value: 'sold', label: 'Sold' },
  ];

  return (
    <div className="page">
      <div className="flex items-center justify-between py-6">
        <h2 className="text-xl font-bold">Inventory</h2>
        <Link to="/add" className="btn-primary text-sm py-2 px-4">+ Add</Link>
      </div>

      {/* Search */}
      <input
        type="text"
        placeholder="Search make, model, VIN..."
        className="input w-full mb-4"
        value={search}
        onChange={(e) => { setSearch(e.target.value); setPage(1); }}
      />

      {/* Status Filters */}
      <div className="flex gap-2 mb-6 overflow-x-auto pb-2">
        {STATUSES.map((s) => (
          <button
            key={s.value}
            onClick={() => { setStatus(s.value); setPage(1); }}
            className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors ${
              status === s.value
                ? 'bg-brand-600 text-white'
                : 'bg-surface-800 text-surface-400 hover:text-white'
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>

      {/* Results */}
      {isLoading ? (
        <div className="text-center py-12 text-surface-500">Loading...</div>
      ) : vehicles.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-surface-500">No vehicles found</p>
          <Link to="/add" className="text-brand-400 text-sm mt-2 inline-block">Add your first vehicle</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {vehicles.map((v: any) => (
            <VehicleCard key={v.id} vehicle={v} />
          ))}
        </div>
      )}

      {/* Pagination */}
      {pagination && pagination.totalPages > 1 && (
        <div className="flex justify-center gap-2 mt-6">
          <button
            onClick={() => setPage(Math.max(1, page - 1))}
            disabled={page <= 1}
            className="btn-ghost text-sm disabled:opacity-30"
          >
            Prev
          </button>
          <span className="text-surface-500 text-sm py-2">
            {page} / {pagination.totalPages}
          </span>
          <button
            onClick={() => setPage(Math.min(pagination.totalPages, page + 1))}
            disabled={page >= pagination.totalPages}
            className="btn-ghost text-sm disabled:opacity-30"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
